import * as React from "react";
import { Helmet } from "react-helmet";
import { Block } from "baseui/block";
import { SIZE } from "baseui/input";

import { expandMargin } from "kanopi-components/utils/styles";

import { displayRegistry } from "../DisplayRegistry";
import { inputRegistry } from "./inputs";
import { getSubdomain } from "../utils";

type TExtendedQuestion = { hidden: boolean } & TQuestion;

// TODO fix this type being all optionals...
type TQuestionProps = {
  question?: TExtendedQuestion;
  autoFocus?: boolean;
  size?: string; // TODO limit to SIZE
  prefix?: string;
  editable?: boolean;
  value?: unknown;
  label?: string;
  [key: string]: TODO;
};

const InnerQuestion: React.FC<TQuestionProps> = (props) => {
  const {
    question = {} as TExtendedQuestion,
    size = SIZE.default,
    prefix = "",
    editable = true,
    value,
    ...restProps
  } = props;
  const { inputType, inputArgs = {}, label, help, hidden, ...questionProps } = question;
  const { InputComponent, ...inputComponentProps } = React.useMemo(() => {
    if (editable) {
      return { InputComponent: inputRegistry.getByType(inputType) };
    }
    return { InputComponent: displayRegistry.getByType(inputType), answer: value };
  }, [inputType, editable, value]);
  // Hidden questions are useful in situations where we're adding
  // extra questions to an existing question set. E.g. policy holder
  // details that come with some questions for email and password.
  if (!InputComponent || hidden) {
    return null;
  }
  const name = `${prefix}${question.id}`;

  const subdomain = getSubdomain();

  return (
    <>
      <Helmet>
        <title>{subdomain} Quote</title>
      </Helmet>
      <Block {...getMargins(size)}>
        <InputComponent
          label={label}
          help={help}
          size={size}
          value={value}
          {...questionProps}
          {...restProps}
          {...inputArgs}
          {...inputComponentProps}
          name={name}
          id={name}
        />
      </Block>
    </>
  );
};

export const Question = React.memo(InnerQuestion);

function getMargins(size) {
  if (size === SIZE.mini) {
    return expandMargin("auto");
  }
  return { marginBottom: ["scale600", "scale800"] };
}

export { SIZE };
